import {FormattedMessage} from "react-intl";

import * as yup from "yup";
import "yup-phone-lite";

import {ShippingMethodsDiscr} from "utils/ShippingMethods";

const regexPhoneNumber = /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/;

export default function getValidationSchema(isWaybill, isReturnWaybill, shippingMethods, isEditing) {
    return yup.object({
        name: createRequiredStringValidation('name'),
        shopName: createRequiredStringValidation('shopName').test('testShopName',  (value, {path, createError}) => {
            if (isEditing) {
                return true;
            }

            const alreadyExist = shippingMethods?.some(shippingMethod => shippingMethod.shopName?.toLowerCase() === value?.toLowerCase());

            if (alreadyExist) {
                return createError({
                    message: <FormattedMessage id={`shippingMethods.form.field.${path}.error.alreadyExist`}/>
                });
            }

            return true;
        }),
        shippingMethodShopName: createRequiredStringValidation('shippingMethodShopName'),
        icon: yup.string().nullable(),
        discr: createRequiredStringValidation('discr'),
        skipReservedStep: yup.bool(),
        senderName: createConditionalFieldValidation('testSenderName', isWaybill),
        contactMailAddress: createConditionalFieldValidation('testContactMailAddress', isWaybill, 'email'),
        contactPhoneNumber: createConditionalFieldValidation('testContactPhoneNumber', isWaybill, 'phone'),
        senderAddress: createConditionalFieldValidation('testSenderAddress', isWaybill),
        contractNumber: createConditionalFieldValidation('testContractNumber', isWaybill),
        wsPassword: createConditionalFieldValidation('testWsPassword', isWaybill),
        printConfig: yup.lazy(value =>
            Array.isArray(value)
                ? yup.array().of(yup.object().shape({})) // Allow empty array
                : yup.object().shape({
                    returnShippingMethodOverride: isReturnWaybill
                        ? yup.string().required('shippingMethods.form.field.printConfig.returnShippingMethodOverride.error.required')
                        : yup.string().nullable(),
                })
        ),
        additionalData: yup.lazy(value =>
            Array.isArray(value)
                ? yup.array().of(yup.object().shape({})) // Allow empty array
                : yup.object().shape({
                    sandbox: yup.bool(),
                    customerNumber: createConditionalAdditionalDataFieldValidation('testCustomerNumber', [ShippingMethodsDiscr.POSTNL, ShippingMethodsDiscr.NSHIFT]),
                    carrierServiceId: createConditionalAdditionalDataFieldValidation('testCarrierServiceId', [ShippingMethodsDiscr.NSHIFT]),
                    returnCarrierServiceId: createConditionalAdditionalDataFieldValidation('testReturnCarrierServiceId', [ShippingMethodsDiscr.NSHIFT]),
                    api_url: createConditionalAdditionalDataFieldValidation('testApiUrl', [ShippingMethodsDiscr.GEODIS]),
                    api_username: createConditionalAdditionalDataFieldValidation('testApiUsername', [ShippingMethodsDiscr.GEODIS]),
                    api_key: createConditionalAdditionalDataFieldValidation('testApiKey', [ShippingMethodsDiscr.GEODIS]),
                    agency_code: createConditionalAdditionalDataFieldValidation('testAgencyCode', [ShippingMethodsDiscr.GEODIS]),
                    client_code: createConditionalAdditionalDataFieldValidation('testClientCode', [ShippingMethodsDiscr.GEODIS]),
                    product_code: createConditionalAdditionalDataFieldValidation('testProductCode', [ShippingMethodsDiscr.GEODIS]),
                    sender_name: createConditionalAdditionalDataFieldValidation('testApiSenderName', [ShippingMethodsDiscr.GEODIS]),
                    sender_country_code: createConditionalAdditionalDataFieldValidation('testSenderCountryCode', [ShippingMethodsDiscr.GEODIS]),
                    sender_post_code : createConditionalAdditionalDataFieldValidation('testPostCode', [ShippingMethodsDiscr.GEODIS]),
                    sender_city: createConditionalAdditionalDataFieldValidation('testSenderCity', [ShippingMethodsDiscr.GEODIS]),
                }),
        ),
    });
}

function createRequiredStringValidation(name) {
    return yup.string().required(<FormattedMessage id={`shippingMethods.form.field.${name}.error.required`}/>);
}

function createConditionalAdditionalDataFieldValidation(testName, methods) {
    return yup.string().nullable().test(
        testName,
        (value, {path, createError, from}) => {
            // https://github.com/jquense/yup/issues/225
            // when we are on nested object, we cant use .when() to access parent values like discr
            const discr = from[1].value.discr;

            // validation fail
            if (methods.includes(discr) && (value === null || !value || value.trim() === '')) {
                return createError({
                    message: <FormattedMessage id={`shippingMethods.form.field.${path}.error.required`} />
                });
            }

            // validation pass
            return true;
        }
    );
}

function createConditionalFieldValidation(testName, condition, type = 'string') {
    let customYup = yup.string();

    if (type === 'email') {
        customYup = yup.string().email()
    }

    if (type === 'phone') {
        customYup = yup.string().matches(regexPhoneNumber, ({path}) => {
            return <FormattedMessage id={`shippingMethods.form.field.${path}.error.notValid`} />
        })
    }

    return customYup.nullable().test(
        testName,
        (value, {path, createError}) => {
            // validation fail
            if (condition === true && (value === null || !value || value.trim() === '')) {
                return createError({
                    message: <FormattedMessage id={`shippingMethods.form.field.${path}.error.required`} />
                });
            }

            // validation pass
            return true;
        }
    );
}


